import {get,getAll} from './veronicaview';
import country from './country'
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';

(function() {
    'use strict'
 let getcountry,phone =null;
 let overlay = document.getElementsByClassName('loading-overlay')[0]
 const uri='/wp-content/themes/vvhotel/mail/book-now-tours-mail.php'
    // const slect= get('#country_tours')
    let pais = get('#country_tours');
            if (pais) {
                let code_pais = get('#code_country'),
                    templatePais = "",
                    $lag = document.querySelector("meta[property='og:locale']").getAttribute("content");
                country.forEach(element => {
                    //  ban += `<span class="flag ${element.code.toLocaleLowerCase()}"></span>`;
                    if ($lag == "es_ES") {
                        if (element.code == "US") {
                            phone=element.dial_code;
                            getcountry=element.name_en || element.name_es;
                            code_pais.innerHTML = element.dial_code;
                            templatePais += `<option selected value="${element.code}">${element.name_en} </option> `
                            code_pais.innerHTML = element.dial_code;
                            code_pais.insertAdjacentHTML('afterbegin', `<span class="flag ${element.code.toLocaleLowerCase()}"></span>`);
                        } else {
                            templatePais += `<option value="${element.code}">${element.name_en} </option> `
                        }
                    }
                    if ($lag == "en_US") {
                        if (element.code == "US") {
                            phone=element.dial_code;
                            getcountry=element.name_en || element.name_es;
                            code_pais.innerHTML = element.dial_code;
                            templatePais += `<option selected value="${element.code}">${element.name_en} </option> `
                            code_pais.innerHTML = element.dial_code;
                            code_pais.insertAdjacentHTML('afterbegin', `<span class="flag ${element.code.toLocaleLowerCase()}"></span>`);
                        } else {
                            templatePais += `<option value="${element.code}">${element.name_en} </option> `
                        }
                    }

                })
                pais.innerHTML = templatePais;
                //  a.insertAdjacentHTML('beforeend', ban);
                //////////////////////////////// initial choices js ////////////////////////////
                const choices = new Choices(pais);
                /////////////////////////// onchange country /////////////////////////////
                pais.addEventListener('change', () => {
                    country.forEach(element => {
                        if (pais.value == element.code) {
                              phone=element.dial_code;
                              getcountry=element.name_en || element.name_es;
                             code_pais.innerHTML = element.dial_code;
                            code_pais.insertAdjacentHTML('afterbegin', `<span class="flag ${element.code.toLocaleLowerCase()}"></span>`);
                            console.log(phone);
                        }
                    })
                })
            }
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.v-form-validate')
     
    // Loop over them and prevent submission
    Array.prototype.slice.call(forms)
        .forEach(function(form) {
            form.addEventListener('submit', function(event) {
                event.preventDefault()
                overlay.classList.toggle('is-active')
                if (!hasvalidate(form)) {
                    overlay.classList.remove('is-active')
                    form.classList.add('was-validated')
                    event.stopPropagation()
                }
                if (form.checkValidity()) {
                    
                    const __data=new FormData;
                      __data.append('vv_tours', form.vv_tours.value);
                      __data.append('travel_date', form.date_travel.value);
                      __data.append('num_pass', form.numberspass.value);
                      __data.append('type_tours', form.Private.value);
                      __data.append('email', form.address.value);
                      __data.append('fullname', form.fullname.value);
                      __data.append('country', getcountry);
                      __data.append('phone',`${phone}`+form.phone.value);
                      __data.append('age_exist', form.age_17.value);
                      __data.append('adicional', form.adicional.value);
                      __data.append('Hdyahotel', form.Hdyahotel.value);
                      __data.append('terms', form.terms.value);
                     fetch(uri,{method:'POST',body:__data})
                     .then(response =>response.json())
                     .then(data =>{
                         console.log(data);
                         if(data.success){
                             form.reset();
                            overlay.classList.remove('is-active')
                            Swal.fire({
                                icon: 'success',
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                title: 'Thank you, your reservation was made successfully',
                                footer: '<a href="https://www.veronicaviewhotel.com/">Go back to start</a>'
                            })
                         }else{
                            Swal.fire({
                                title: 'Error Sending',
                                icon: 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                            overlay.classList.remove('is-active')
                      
                         }
                     })
                }
            }, false)
        })

    const hasvalidate = (from) => {
    
    }
})()